import {useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { LoginContainer } from './login.container';
import { BasePageStyles } from '../../hooks/styles';
import { Container } from '@mui/material';
const Login = () => {
  const classes = BasePageStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <LoginContainer />
      </Container>
    </BasePage>
  )
}

export default Login; 